import React from 'react';

/**
 * Formats a value for display in a table cell
 * @param {*} value - The value to format
 * @returns {React.ReactNode} - The formatted value as a React node
 */
export const formatValueForTable = (value) => {
	if (value === null || value === undefined) {
		return <span className="text-base-content/50 italic">N/A</span>;
	}
	if (typeof value === 'boolean') {
		return value ? 'Yes' : 'No';
	}
	if (Array.isArray(value)) {
		return value.join(', ');
	}
	// Handle objects by converting them to strings
	if (typeof value === 'object' && value !== null) {
		return <pre className="text-xs whitespace-pre-wrap">{JSON.stringify(value, null, 2)}</pre>;
	}
	// Basic string conversion for other types
	return String(value);
};
